/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Subject } from 'rxjs';
import { groupBy, mergeMap, debounceTime, tap } from 'rxjs/operators';

/**
 * Sets up a persistence stream that detects essentially duplicate entries within a time interval and culls
 * the oldest that corresponds to each key.
 */
export class SoakPersistence<T> {
	private events = new Subject<T>();

	//an enhancement to consider, back pressure relief. In theory if we infinite loop this, we can run out of memory
	//probably unnecessarily defensive though
	public output$ = this.events.pipe(
		groupBy(this.keyGetter),
		mergeMap((group) => {
			return group.pipe(debounceTime(this.soakTime));
		})
	);

	constructor(private soakTime = 20, private keyGetter: (event: T) => string) {}

	public push(data: T) {
		this.events.next(data);
	}

	//possible issue for later, especially if using a higher soakTime. Any outstanding persists will be lost when calling destroy.
	//It's a hell of a fringe case in the current usage, 20ms and only called on plan exit, so it will be ignored for now...
	public destroy() {
		this.events.complete();
	}
}
